<template>
  <div :class="elem.classes">
    <div class="d-flex justify-content-between" style="gap: 10px;">
      <div class="">
        <div
          :class="elemPreview.classes" 
          class="d-flex justify-content-center cursor-pointer"
          @click="openFileManager"
        >
          <div 
            v-if="image.url" 
            :class="elemPreviewExists.classes" 
            :style="elemPreviewExists.styles" 
          />
          <div 
            v-else 
            :class="elemPreviewEmpty.classes" 
            class="d-flex flex-column align-items-center align-self-center" 
            >
            <div><i class="far fa-image fa-3x"></i></div>
            <strong> Your image </strong>
          </div>
        </div>
      </div>
      <div class="align-self-center text-center">
        <b-button variant="default" @click="openFileManager">
          <i class="far fa-image"></i> {{$t('engine.common.btnBrowse', languageEngine)}}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    image: {
      type: Object,
      default: undefined,
    },
    isShowImage: {
      type: Boolean,
      default: true,
    },
    isShowDocument: {
      type: Boolean,
      default: true,
    },
    isShowFlaticon: {
      type: Boolean,
      default: true,
    },
    isShowIcon: {
      type: Boolean,
      default: true,
    },
    isShowUnsplash: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    // Elements
    elem() {
      return {
        classes: {
          "mwe-imagebrowse": true,
        },
      }
    },
    elemPreview() {
      return {
        classes: {
          "mwe-imagebrowse-preview": true,
        },
      }
    },
    elemPreviewExists() {
      return {
        classes: {
          "mwe-imagebrowse-preview-exists": true,
        },
        styles: {
          "background-image": `url("${this.image.url.replace("{{size}}", "r_100x100")}")`,
        }
      }
    },
    elemPreviewEmpty() {
      return {
        classes: {
          "mwe-imagebrowse-preview-empty": true,
        },
      }
    },
  },
  methods: {
    openFileManager() {
      this.$store.dispatch("design/openFilemanager", {
        onChange: this.onChangeImage,
        isShowImage: this.isShowImage,
        isShowDocument: this.isShowDocument,
        isShowFlaticon: this.isShowFlaticon,
        isShowIcon: this.isShowIcon,
        isShowUnsplash: this.isShowUnsplash,
      });
    },
    onChangeImage(files) {
      this.$emit("change", files);
    },
  },
}
</script>

<style>
.mwe-imagebrowse-preview {
  width: 145px;
  height: 145px;
  background-color: #FFFFFF;
  border: 1px solid var(--line);
  border-radius: 4px;
}
.mwe-imagebrowse-preview-exists {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position:  center;
}
</style>
